import { CatalogItem } from '@/shared/types/catalog';
import Link from 'next/link';
import cN from 'classnames';
import { getSupplierAvatar } from '@/shared/utils/catalogHelper';
import RightGrayIcon from '@/components/Common/Icons/RightGrayIcon';
import './index.less';
import Image from 'next/image';
import { useIsMobileURL } from '@/shared/hooks';

interface IProps {
  product: CatalogItem;
}

const SupplierOverview = ({ product }: IProps) => {
  const supplier = product.catalogCompany;
  const isMobileURL = useIsMobileURL();
  const avatarUrl = getSupplierAvatar(supplier);

  return (
    <Link
      className={cN('supplier-name-box', { 'supplier-name-box-mobile': isMobileURL })}
      href={`/sourcing/suppliers/${supplier.handle}`}
    >
      {avatarUrl && <Image width={32} height={32} alt="avatar" className="avatar-img" src={avatarUrl} loading="lazy" />}
      <span className="supplier-name">{supplier.name}</span>
      <RightGrayIcon />
    </Link>
  );
};

export default SupplierOverview;
